module.exports = __webpack_public_path__ + "static/media/measurements_coming_soon.6301773a.png";